module.exports = __webpack_public_path__ + "static/Landing_Illustration-02.55b4641d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing_Illustration-02.png
// module id = 466
// module chunks = 114276838955818